import React, { Component } from "react";
import Footer from "../component/Footer";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oid: props.match.params.oid,
      registerok: false,
      account: "",
      password: "",
      repassword: "",
      name: "",
      mobile: "",
      email: "",
      company: "",
      tel: "",
      fax: "",
      addr: "",
      department: "",
      position: "",
      homepage: "",
    };
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }
  componentDidMount() {}

  // 이메일 형식 확인
  validateEmail(email) {
    var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  handleFormSubmit(e) {
    const {
      account,
      password,
      repassword,
      name,
      mobile,
      email,
      company,
      tel,
      fax,
      addr,
      department,
      position,
      homepage,
    } = this.state;

    if (account.length === 0) {
      alert("계정 정보를 입력해 주세요.");
      return;
    }
    if (!this.validateEmail(account)) {
      alert("계정 정보는 이메일 형식이어야 합니다.");
      return;
    }
    if (password.length === 0) {
      alert("비밀번호 정보를 입력해 주세요.");
      return;
    }
    if (repassword.length === 0) {
      alert("비밀번호 확인 정보를 입력해 주세요.");
      return;
    }
    if (name.length === 0) {
      alert("이름 정보를 입력해 주세요.");
      return;
    }
    if (mobile.length === 0) {
      alert("전화번호 정보를 입력해 주세요.");
      return;
    }
    if (company.length === 0) {
      alert("회사명 정보를 입력해 주세요.");
      return;
    }
    if (password !== repassword) {
      alert("비밀번호 정보를 확인해 주십시오.");
      return;
    }

    let semail = email;
    if (semail.length === 0) semail = account;
    else {
      if (!this.validateEmail(email)) {
        alert("이메일 형식이 아닙니다.");
        return;
      }
    }

    axios
      .post("https://happyqr.net/api/starname/api/RN_register", {
        account: {
          account: account,
          password: password,
          oid: this.state.oid,
        },
        namecard: {
          name: name,
          mobile: mobile,
          company: company,
          email: semail,
          tel: tel,
          fax: fax,
          addr: addr,
          department: department,
          position: position,
          homepage: homepage,
        },
      })
      .then((data) => {
        if (data.data.code == 200) {
          console.log(data.data);
          this.setState({ registerok: true });
        } else if (data.data.code == 401) {
          alert("이미 등록되어 있는 아이디 입니다.");
        } else {
          alert("다시 시도해 주세요.");
        }
      })
      .catch((error) => {
        alert("서버와의 통신이 원활하지 않습니다.");
      });
  }

  handleValueChange(e) {
    let nextState = {};
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  }

  renderHeader() {
    return (
      <img
        src={"/mainlogo.png"}
        style={{ height: "30px", backgroundSize: "contain" }}
      ></img>
    );
  }

  render() {
    if (this.state.registerok) {
      return (
        <div className="register-main">
          <div className="header">{this.renderHeader()}</div>
          <img src="/starname_info.png" width="100%" />
          <div>
            <div
              style={{ marginTop: -10, paddingTop: 30, textAlign: "center" }}
            >
              정상 가입 되었습니다.
            </div>
            <div style={{ textAlign: "center" }}>
              앱 설치 후 결제가 완료되면
            </div>
            <div style={{ textAlign: "center" }}>
              나만의 명함을 편집 할 수 있습니다.
            </div>
            <a href="https://play.google.com/store/apps/details?id=com.osung.starname">
              <img
                style={{ paddingLeft: 30, paddingRight: 30, paddingTop: 10 }}
                width="100%"
                alt="다운로드하기 Google Play"
                src="https://play.google.com/intl/ko/badges/images/generic/ko_badge_web_generic.png"
              />
            </a>
          </div>
        </div>
      );
    } else {
      return (
        <div className="register-main">
          <div className="header">{this.renderHeader()}</div>

          <div style={{ margin: 10 }}>
            <TextField
              name="account"
              type="email"
              label="*계정( 이메일 주소를 입력해 주세요. )"
              fullWidth
              value={this.state.account}
              onChange={this.handleValueChange}
            ></TextField>
            <TextField
              name="password"
              type="password"
              label="*비밀번호"
              fullWidth
              value={this.state.password}
              onChange={this.handleValueChange}
            ></TextField>
            <TextField
              name="repassword"
              type="password"
              label="*비밀번호 확인"
              fullWidth
              value={this.state.repassword}
              onChange={this.handleValueChange}
            ></TextField>
            <TextField
              name="name"
              type="text"
              label="*이름"
              fullWidth
              value={this.state.name}
              onChange={this.handleValueChange}
            ></TextField>
            <TextField
              name="mobile"
              type="tel"
              label="*전화번호"
              fullWidth
              value={this.state.mobile}
              onChange={this.handleValueChange}
            ></TextField>
            <TextField
              name="company"
              type="text"
              label="*회사명"
              fullWidth
              value={this.state.company}
              onChange={this.handleValueChange}
            ></TextField>
            {/* 
                        <TextField name='email' type='email' label='이메일 ( 미 입력시 계정 정보와 동일 )' fullWidth value={this.state.email} onChange={this.handleValueChange}></TextField>
                        <TextField name='tel' type='tel' label='회사전화' fullWidth value={this.state.tel} onChange={this.handleValueChange}></TextField>
                        <TextField name='addr' type='text' label='주소' fullWidth value={this.state.addr} onChange={this.handleValueChange}></TextField>
                        <TextField name='department' type='text' label='부서' fullWidth value={this.state.department} onChange={this.handleValueChange}></TextField>
                        <TextField name='position' type='text' label='직책' fullWidth value={this.state.position} onChange={this.handleValueChange}></TextField>
                        <TextField name='homepage' type='url' label='홈페이지' fullWidth value={this.state.homepage} onChange={this.handleValueChange}></TextField>
                        */}
            <Button
              variant="contained"
              fullWidth
              style={{
                marginTop: 10,
                backgroundColor: "#ed1c24",
                color: "white",
              }}
              onClick={this.handleFormSubmit}
            >
              등 록
            </Button>
          </div>

          <Footer />
        </div>
      );
    }
  }
}

export default Register;
